import React from 'react'
import PropTypes from 'prop-types'

import './SelectInput.scss'

const SelectInput = ({ name, options, defaultValue, label, disabledLabel, className, ...props }) => (
  <div className={`select-input ${className}`}>
    {
      !disabledLabel &&
      <label htmlFor={name}>{label}</label>
    }
    
    <select
      id={name}
      {...props}
    >
      <option value="">
        {defaultValue || ''}
      </option>
      {
        options.map(option => (
          <option
            key={option.key || option.id}
            value={option.key || option.id}
          >
            {option.label}
          </option>
        ))
      }
    </select>
  </div>
)

SelectInput.defaultProps = {
  label: '',
  defaultValue: '',
  name: '',
  className: '',
  options: [],
  disabledLabel: false,
}

SelectInput.propTypes = {
  label: PropTypes.string,
  defaultValue: PropTypes.string,
  name: PropTypes.string,
  options: PropTypes.array,
}

export default SelectInput



// WEBPACK FOOTER //
// ./src/browser/components/fields/SelectInput.js